import type { DriveStep } from "driver.js";
import type { TFunction } from "i18next";

export const buildDeckTourSteps = (t: TFunction): DriveStep[] => [
  {
    // popover-only: ensureFullscreenDummy で全画面サイズの dummy を先に作っておく前提
    popover: {
      title: t("tour.deck.welcome.title"),
      description: t("tour.deck.welcome.body"),
    },
  },
  {
    element: '[data-tour="services-nav"]',
    popover: {
      title: t("tour.deck.addService.title"),
      description: t("tour.deck.addService.body"),
      side: "bottom",
      align: "center",
    },
  },
  {
    element: '[data-tour="favorite-toggle"]',
    popover: {
      title: t("tour.deck.favorite.title"),
      description: t("tour.deck.favorite.body"),
      side: "top",
      align: "center",
    },
  },
  {
    element: '[data-tour="tag-filter"]',
    popover: {
      title: t("tour.deck.tagFilter.title"),
      description: t("tour.deck.tagFilter.body"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="search-bar"]',
    popover: {
      title: t("tour.deck.search.title"),
      description: t("tour.deck.search.body"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="service-logo"]',
    popover: {
      title: t("tour.deck.serviceLogo.title"),
      description: t("tour.deck.serviceLogo.body"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="service-memo"]',
    popover: {
      title: t("tour.deck.serviceMemo.title"),
      description: t("tour.deck.serviceMemo.body"),
      side: "left",
      align: "start",
    },
  },
  {
    element: '[data-tour="dnd-handle"]',
    popover: {
      title: t("tour.deck.dnd.title"),
      description: t("tour.deck.dnd.body"),
      side: "right",
      align: "start",
    },
  },
  {
    element: '[data-tour="user-menu"]',
    popover: {
      title: t("tour.deck.userMenu.title"),
      description: t("tour.deck.userMenu.body"),
      side: "bottom",
      align: "end",
    },
  },
];
